import { sanitizeString } from 'util/formatter';

import { DEFAULT_PER_PAGE, MESSENGER_BASE_API_URL } from './constants';

export const getTokenApiRoute = () => `${MESSENGER_BASE_API_URL}/tokens`;

export const getTeamLocationMembersApiRoute = (
  locationUuid: string,
  cid: string,
  currentPage: number,
  searchQuery?: string
) =>
  `${MESSENGER_BASE_API_URL}/locations/${sanitizeString(
    locationUuid
  )}/team_members?page=${currentPage}${
    cid ? `&cid=${sanitizeString(cid)}` : ''
  }${
    searchQuery ? `&query=${encodeURIComponent(searchQuery)}` : ''
  }&per_page=${DEFAULT_PER_PAGE}`;

export const createChannelApiRoute = () => `${MESSENGER_BASE_API_URL}/channels`;

export const getQuickActionsApiRoute = (
  locationUuid: string,
  includeChannels: boolean = true,
  cid?: string
) =>
  `${MESSENGER_BASE_API_URL}/locations/${sanitizeString(
    locationUuid
  )}/quick_actions${!includeChannels ? '?exclude_channels=true' : ''}${
    cid ? `&cid=${sanitizeString(cid)}` : ''
  }`;

export const getChannelInfoApiRoute = (
  cid: string,
  page: number = 1,
  searchQuery?: string
) =>
  `${MESSENGER_BASE_API_URL}/channels/${sanitizeString(cid)}?page=${page}${
    searchQuery ? `&query=${encodeURIComponent(searchQuery)}` : ''
  }&per_page=${DEFAULT_PER_PAGE}`;

export const getChannelsToExportApiRoute = (locationUuid: string) =>
  `${MESSENGER_BASE_API_URL}/channels?location_uuid=${sanitizeString(
    locationUuid
  )}`;

export const postExportMessagesApiRoute = () =>
  `${MESSENGER_BASE_API_URL}/channels/export`;
